<template>
  <b-card no-body class="p-2 banner-card container-card">
    <b-row>
      <b-col cols="12">
        <banner-table
          :isAdjusted="getPermissionModule('Banner').adjust"
          :displayKey="dynamicTableConfig.displayKey"
          :queryId="dynamicTableConfig.queryId"
          :queryDataKey="dynamicTableConfig.queryDataKey"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import {
    BRow,
    BCol,
    BCard,
    BButton,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
  } from 'bootstrap-vue';
  import vSelect from 'vue-select';

  import BannerTable from './components/BannerTable.vue';

  import useBannerList from './hooks/useBannerList';

  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BButton,
      BInputGroupPrepend,
      BInputGroup,
      BFormInput,
      BannerTable,
      vSelect,
    },

    setup() {
      const {
        dynamicBIConfig,
        dynamicTableConfig,
        pagination,
        getPermissionModule
      } = useBannerList();
      //0064FA
      //    padding: 0.5rem 1.5rem;

      return { 
        dynamicBIConfig, 
        dynamicTableConfig, 
        pagination,
        getPermissionModule
      };
    },
  };
</script>

<style scoped>
  @import '~@/assets/css/pages/banner/banner.css';
</style>
